import React from 'react';

import Image from '@components/Image';
import {useContainerSize} from '@components/layout';
import {AmbientVideo} from '@components/Video';
import {styled} from '@styles';
import {
  ImageColumnContainer,
  ImageRowContainer,
  GenericImageGrid,
  ResponsiveContainerProps,
} from './OrganicImageGrid';
import {MediaGridBlock} from './types';

const TwoColumnImageGrid = styled(GenericImageGrid).withConfig({
  componentId: 'threeiogvtwoTwoColumnImageGrid'
})<ResponsiveContainerProps>`
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 0.6fr;
`;

export default function ThreeImagesOrganicGridVariantTwo({
  imageBlocks,
  videoBlocks,
}: MediaGridBlock): JSX.Element | null {
  if (!imageBlocks && !videoBlocks) return null;
  const {wide} = useContainerSize();
  const [firstVideo, secondVideo, thirdVideo] = videoBlocks || [];
  const [firstImage, secondImage, thirdImage] = imageBlocks || [];

  const firstSlot = firstVideo ? firstVideo : firstImage;
  const secondSlot =
    firstSlot.video && firstImage
      ? firstImage
      : firstSlot.video && secondVideo
      ? secondVideo
      : secondVideo
      ? secondVideo
      : secondImage;
  const thirdSlot =
    secondSlot.image && thirdImage
      ? thirdImage
      : !firstSlot.video && !secondSlot.video && firstVideo
      ? firstVideo
      : firstSlot.video && secondSlot.image
      ? secondImage
      : thirdVideo
      ? thirdVideo
      : thirdImage;

  return (
    <TwoColumnImageGrid wide={wide}>
      {firstSlot && (
        <ImageColumnContainer wide={wide} justify="flex-start" align="center">
          {firstSlot.image && !firstSlot.video ? (
            <Image
              childImageSharp={firstImage.image.childImageSharp}
              style={{
                // maxWidth:
                //   firstImage.image.childImageSharp.fluid.presentationWidth,
                margin: '0',
                width: wide ? '100%' : '100%',
                height: wide ? 'auto' : '100%',
              }}
              preservePresentationWidth={false}
              alt={firstImage.caption}
              {...firstSlot.image}
            />
          ) : firstSlot.video ? (
            <AmbientVideo videoSrc={firstSlot.video.url} />
          ) : null}
        </ImageColumnContainer>
      )}
      {secondSlot && thirdSlot && (
        <ImageRowContainer wide={wide} align="flex-start" justify="flex-end">
          {secondSlot.image && !secondSlot.video ? (
            <Image
              childImageSharp={secondSlot.image.childImageSharp}
              style={{
                // maxWidth:
                //   secondSlot.image.childImageSharp.fluid.presentationWidth,
                margin: wide ? '0 19px 0 0' : '0 10px 0 0',
                width: wide ? '100%' : '50%',
                height: 'auto',
              }}
              preservePresentationWidth={false}
              alt={secondSlot.caption}
              {...secondSlot.image}
            />
          ) : secondSlot.video ? (
            <AmbientVideo videoSrc={secondSlot.video.url} />
          ) : null}
          {thirdSlot.image && !thirdSlot.video ? (
            <Image
              childImageSharp={thirdSlot.image.childImageSharp}
              style={{
                // maxWidth: wide
                //   ? thirdSlot.image.childImageSharp.fluid.presentationWidth
                //   : 'auto',
                margin: wide ? '0 0 0 19px' : '0 0 0 10px',
                width: wide ? '80%' : '50%',
                height: 'auto',
              }}
              preservePresentationWidth={false}
              alt={thirdSlot.caption}
              {...thirdSlot.image}
            />
          ) : thirdSlot.video ? (
            <AmbientVideo videoSrc={thirdSlot.video.url} />
          ) : null}
        </ImageRowContainer>
      )}
    </TwoColumnImageGrid>
  );
}
